/* =============================================================
 * dopa-first-touch.js  v3 — Size Advisor
 *
 * Luồng:
 *   Step 1: Gender (Nam / Nữ) - Bỏ qua nếu đã truyền sẵn gender
 *   Step 2: Cân nặng — map trực tiếp ra Size
 *   Step 3: Kết quả — "Size vừa vặn nhất với bạn: X"
 * ============================================================= */

(function () {
  'use strict';

  var DISMISSED_KEY  = 'dopa_ft_dismissed';
  var DISMISS_DAYS   = 7;

  var state = {
    gender: null,      // 'NAM' | 'NU'
    weightRange: null, // label string
    size: null,        // 'S' | 'M' | 'L' | 'XL' | '2XL'
    step: 1,
    options: {}
  };

  var overlay, modal;

  /* ── DOM builders ────────────────────────────────────────── */
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  function btn(cls, text) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.innerHTML = text;
    return b;
  }

  /* ── Render helpers ──────────────────────────────────────── */
  function setHeading(text) {
    modal.querySelector('.dopa-ft-heading').textContent = text;
  }
  function setSub(text) {
    modal.querySelector('.dopa-ft-sub').textContent = text;
  }
  function setStepDots(current, total) {
    var dots = modal.querySelector('.dopa-ft-steps');
    dots.innerHTML = '';
    for (var i = 1; i <= total; i++) {
      var d = el('span', 'dopa-ft-step-dot' + (i === current ? ' active' : ''));
      dots.appendChild(d);
    }
  }
  function clearBody() {
    modal.querySelector('.dopa-ft-body').innerHTML = '';
  }
  function body() {
    return modal.querySelector('.dopa-ft-body');
  }

  /* ── STEP 1: Gender ──────────────────────────────────────── */
  function renderStep1() {
    state.step = 1;
    setHeading('Bạn đang chọn đồ Nam hay Nữ?');
    setSub('');
    setStepDots(1, 3);
    clearBody();

    var row = el('div', 'dopa-ft-genders');

    [
      { val: 'NAM', icon: '👨‍⚕️', label: 'Nam' },
      { val: 'NU',  icon: '👩‍⚕️', label: 'Nữ' },
    ].forEach(function (g) {
      var b = el('button', 'dopa-ft-gender-btn', '');
      b.type = 'button';
      b.innerHTML = '<span class="icon">' + g.icon + '</span>' + g.label;
      b.addEventListener('click', function () {
        state.gender = g.val;
        renderStep2_weight();
      });
      row.appendChild(b);
    });

    body().appendChild(row);
  }

  /* ── STEP 2: Cân nặng ───────────────────────────────────── */
  function renderStep2_weight() {
    state.step = 2;
    setHeading('Bạn nặng khoảng bao nhiêu?');
    setSub('Chọn nhóm gần nhất — không cần chính xác');
    setStepDots(state.genderPreSelected ? 1 : 2, state.genderPreSelected ? 2 : 3);
    clearBody();

    var buckets = [];
    if (state.gender === 'NAM') {
      buckets = [
        { label: '50–58 kg' },
        { label: '59–68 kg' },
        { label: '69–78 kg' },
        { label: '79–88 kg' },
        { label: '89–98 kg' },
        { label: '99–108 kg' }
      ];
    } else {
      buckets = [
        { label: '45–52 kg' },
        { label: '53–59 kg' },
        { label: '60–67 kg' },
        { label: '68–75 kg' }
      ];
    }

    var grid = el('div', 'dopa-ft-weights' + (state.gender === 'NU' ? ' dopa-ft-weights--2col' : ''));
    var selectedBtn = null;

    buckets.forEach(function (bk) {
      var b = btn('dopa-ft-weight-btn', '');
      b.innerHTML = bk.label.replace(' kg', '<span class="dopa-ft-unit"> kg</span>');
      b.addEventListener('click', function () {
        if (selectedBtn) selectedBtn.classList.remove('selected');
        b.classList.add('selected');
        selectedBtn = b;
        state.weightRange = bk.label;
        var match = bk.label.match(/(\d+)[–-](\d+)/);
        if (match) {
          state.weightKg = (parseInt(match[1]) + parseInt(match[2])) / 2;
        } else {
          state.weightKg = parseInt(bk.label);
        }
        setTimeout(function () { renderStep3_result(); }, 220);
      });
      grid.appendChild(b);
    });

    body().appendChild(grid);

    if (!state.genderPreSelected) {
      var back = btn('dopa-ui-btn dopa-ui-btn--ghost w-100 mt-20', '← Quay lại');
      back.addEventListener('click', renderStep1);
      body().appendChild(back);
    }
  }

  /* ── STEP 3: Kết quả ─────────────────────────────────────── */
  function renderStep3_result() {
    state.step = 3;
    setStepDots(state.genderPreSelected ? 2 : 3, state.genderPreSelected ? 2 : 3);
    clearBody();

    var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
    var recommendFn = window.DOPA_SIZE_RECO ? window.DOPA_SIZE_RECO.recommendSizeByWeight : null;
    
    if (isProductPage) {
      // PRODUCT PAGE CONTEXT
      var chart = window.DOPA_SIZE_CHART;
      var recoSize = (recommendFn && chart) ? recommendFn(state.weightKg, chart, null) : null;
      
      setHeading('Size vừa vặn nhất với bạn:');
      setSub('Dựa trên số đo bạn vừa cung cấp');

      if (recoSize) {
        var resultBox = el('div', 'dopa-ft-result',
          '<span class="dopa-ft-result-size">' + recoSize + '</span>' +
          '<span class="dopa-ft-result-label">Cho sản phẩm bạn đang xem</span>'
        );
        body().appendChild(resultBox);
        
        var optionsDiv = el('div', 'dopa-ft-options', '');
        optionsDiv.style.display = 'block';
        var addBtn = btn('dopa-ui-btn dopa-ui-btn--primary w-100 mt-20', 'Thêm Size ' + recoSize + ' vào giỏ');
        addBtn.addEventListener('click', function() {
          var form = document.querySelector('form[action^="/cart/add"]');
          if (form) {
            var variantInput = form.querySelector('input[name="id"]');
            var select = form.querySelector('select[name="id"]');
            
            if (select) {
              var options = select.options;
              for (var i = 0; i < options.length; i++) {
                if (options[i].text.indexOf(recoSize) !== -1 || options[i].getAttribute('data-title') === recoSize || options[i].text.split('/').some(t => t.trim() === recoSize)) {
                  select.value = options[i].value;
                  if (variantInput) variantInput.value = options[i].value;
                  break;
                }
              }
            }
            
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              var sBtn = form.querySelector('button[type="submit"]');
              if (sBtn) sBtn.click();
            }
          }
          close();
        });
        optionsDiv.appendChild(addBtn);
        body().appendChild(optionsDiv);
      } else {
        var resultBox = el('div', 'dopa-ft-result',
          '<span class="dopa-ft-result-size" style="font-size: 24px;">Không tìm thấy size</span>' +
          '<span class="dopa-ft-result-label">Vui lòng thử lại cân nặng khác</span>'
        );
        body().appendChild(resultBox);
      }

    } else {
      // GLOBAL CONTEXT
      setHeading('Kết quả phân tích form dáng:');
      setSub('Gợi ý size cho các dòng sản phẩm của dope 🔥');
      
      var globalCharts = window.DOPA_GLOBAL_CHARTS;
      var genderKey = state.gender === 'NAM' ? 'NAM' : 'NU';
      var charts = globalCharts ? globalCharts[genderKey] : null;
      
      var coatData = charts && charts.coat ? charts.coat : null;
      var carbonData = charts && charts.carbon ? charts.carbon : null;
      var nanoData = charts && charts.nano ? charts.nano : null;

      var coatSize = (recommendFn && coatData && coatData.chart) ? recommendFn(state.weightKg, coatData.chart, null) : null;
      var carbonSize = (recommendFn && carbonData && carbonData.chart) ? recommendFn(state.weightKg, carbonData.chart, null) : null;
      var nanoSize = (recommendFn && nanoData && nanoData.chart) ? recommendFn(state.weightKg, nanoData.chart, null) : null;
      
      var coatHandle = state.gender === 'NAM' ? 'steadfast-coat' : 'empower-coat';
      var carbonHandle = state.gender === 'NAM' ? 'iron-carbon-antimicrobial-scrub' : 'glow-carbon-antimicrobial-scrub';
      var nanoHandle = state.gender === 'NAM' ? 'iron-nano-shield-scrub' : 'glow-nano-shield-scrub';
      
      var optionsDiv = el('div', 'dopa-ft-options', '');
      
      var createProductRow = function(title, handle, size, imageUrl) {
        if (!size) return;
        var html = '';
        if (imageUrl) {
          html += '<img src="' + imageUrl + '" class="dopa-ft-product-img" alt="' + title + '" loading="lazy" />';
        }
        html += '<div class="dopa-ft-product-content">';
        html += '<span class="dopa-ft-option-title">' + title + '</span>';
        html += '<span class="dopa-ft-option-sub" style="margin-top: 4px; display: inline-block; color: var(--ink-secondary); font-weight: 500;">Gợi ý: Size ' + size + '</span>';
        html += '</div>';
        
        var opt = btn('dopa-ft-option-btn dopa-ft-product-row', html);
        opt.addEventListener('click', function() {
            close();
            window.location.href = '/products/' + handle + '?variant_size=' + encodeURIComponent(size);
        });
        optionsDiv.appendChild(opt);
      };
      
      createProductRow(coatData && coatData.title ? coatData.title : 'Áo Blouse (' + (state.gender === 'NAM' ? 'Steadfast' : 'Empower') + ')', coatHandle, coatSize, coatData ? coatData.image : '');
      createProductRow(carbonData && carbonData.title ? carbonData.title : 'Carbon Scrub (' + (state.gender === 'NAM' ? 'Iron' : 'Glow') + ')', carbonHandle, carbonSize, carbonData ? carbonData.image : '');
      createProductRow(nanoData && nanoData.title ? nanoData.title : 'Nano Shield Scrub (' + (state.gender === 'NAM' ? 'Iron' : 'Glow') + ')', nanoHandle, nanoSize, nanoData ? nanoData.image : '');
      
      if (!optionsDiv.hasChildNodes()) {
         var noMatch = el('div', 'dopa-ft-result', 'Chưa có size phù hợp');
         body().appendChild(noMatch);
      } else {
         body().appendChild(optionsDiv);
      }
    }

    if (!state.options.hideSecondaryBtn && state.options.showSecondaryBtn) {
      var continueBtn = btn('dopa-ui-btn dopa-ui-btn--ghost w-100 mt-10', 'Tiếp tục xem trang này');
      continueBtn.addEventListener('click', close);
      body().appendChild(continueBtn);
    }
  }

  /* ── URL builder ─────────────────────────────────────────── */
  function buildCollectionUrl(size, gender) {
    var base = '/collections/all';
    var params = [];
    if (gender) {
      params.push('filter.p.tag=' + encodeURIComponent(gender.toLowerCase()));
    }
    if (size) {
      params.push('filter.p.option.Size=' + encodeURIComponent(size));
    }
    return params.length ? base + '?' + params.join('&') : base;
  }

  /* ── Build DOM ───────────────────────────────────────────── */
  function build() {
    overlay = el('div', 'dopa-ft-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'dope 🔥 — chọn loại mua hàng');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });

    modal = el('div', 'dopa-ft-modal');

    var closeBtn = el('button', 'dopa-ft-close', '×');
    closeBtn.setAttribute('aria-label', 'Đóng');
    closeBtn.addEventListener('click', dismiss);
    modal.appendChild(closeBtn);

    modal.appendChild(el('div', 'dopa-ft-heading', ''));
    modal.appendChild(el('div', 'dopa-ft-sub', ''));
    modal.appendChild(el('div', 'dopa-ft-steps', ''));
    modal.appendChild(el('div', 'dopa-ft-body', ''));

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.addEventListener('keydown', onKeydown);

    if (state.gender) {
      renderStep2_weight();
    } else {
      renderStep1();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') dismiss();
  }

  /* ── Dismiss ─────────────────────────────────────────────── */
  function dismiss() {
    try { localStorage.setItem(DISMISSED_KEY, String(Date.now())); } catch (e) {}
    close();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-visible');
    document.removeEventListener('keydown', onKeydown);
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      overlay = null;
      modal   = null;
    }, 280);
  }

  /* ── Public re-open ──────────────────────────────────────── */
  window.DOPA = window.DOPA || {};
  window.DOPA.openFirstTouch = function (gender, options) {
    if (overlay) return;
    state = { 
      gender: gender || null, 
      genderPreSelected: !!gender,
      weightRange: null, 
      size: null, 
      step: gender ? 2 : 1,
      options: options || {}
    };
    build();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    });
  };

})();
